import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { Popover, PopoverContent, PopoverTrigger } from '../../../../web/components-v2/Popover';
import { ListFilterIcon } from '../../../../web/components/svgs/icons/ListFilterIcon';
import { CallLogUrlFilters, SECONDARY_FILTER_KEYS } from '../callLogFilters';
import { SecondaryFilterFields } from './SecondaryFilterFields';
import { styleSheet } from './styles';

interface IProps {
	filters: CallLogUrlFilters;
	onChange: (next: Partial<CallLogUrlFilters>) => void;
	onReset: () => void;
}

export const MoreFiltersPopover: React.FC<IProps> = ({ filters, onChange, onReset }) => {
	const [open, setOpen] = React.useState(false);
	const activeCount = SECONDARY_FILTER_KEYS.filter(key => !!filters[key]).length;

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button type='button' variant='outline'>
					<ListFilterIcon width={16} height={16} />
					{activeCount ? `More filters (${activeCount})` : 'More filters'}
				</Button>
			</PopoverTrigger>
			<PopoverContent align='start' styles={[styleSheet.moreFilters]}>
				<SecondaryFilterFields filters={filters} enabled={open} onChange={onChange} />
				<div className={css(styleSheet.moreFiltersFooter)}>
					<Button type='button' variant='secondary' size='sm' disabled={!activeCount} onClick={onReset}>
						Reset
					</Button>
				</div>
			</PopoverContent>
		</Popover>
	);
};
